export enum StripePayment {
	Card = 'card',
	Sepa = 'sepa_debit'
}
